import { ErrorCode } from './error-codes';

export const AUTH_SESSION_ERROR_CODES: readonly ErrorCode[] = [
  ErrorCode.SESSION_EXPIRED,
  ErrorCode.SESSION_EXPIRED2,
  ErrorCode.PARALLEL_LOGIN,
  ErrorCode.CAS_SIGNOUT,
  ErrorCode.TIMEOUT_SIGNOUT,
  ErrorCode.SUPERADMIN_SIGNOUT,
];

export const UPLOAD_SESSION_ERROR_CODES: readonly ErrorCode[] = [ErrorCode.UPLOAD_SESSION_EXPIRED];

const AUTH_SESSION_ERROR_CODES_SET = new Set<ErrorCode>(AUTH_SESSION_ERROR_CODES);
const UPLOAD_SESSION_ERROR_CODES_SET = new Set<ErrorCode>(UPLOAD_SESSION_ERROR_CODES);

export function isAuthSessionError(errorCode: number | undefined): boolean {
  return errorCode != null && AUTH_SESSION_ERROR_CODES_SET.has(errorCode);
}

export function isSessionError(errorCode: number | undefined): boolean {
  return isAuthSessionError(errorCode) || (errorCode != null && UPLOAD_SESSION_ERROR_CODES_SET.has(errorCode));
}

export function isUploadNotFoundError(errorCode: number | undefined): boolean {
  return errorCode === ErrorCode.UPLOAD_NOT_FOUND;
}
